// extracted by mini-css-extract-plugin
module.exports = {"item":"item-2XltU","item_active":"item_active-3ZIR0"};